import { useCallback, useState } from 'react';
import useUI from '../../context/useUI';
import useHttp from '../../http/useHttp';

export default function usePatchAssociations(custodianId: any) {
  const { showSnackbar } = useUI();
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const { patchDataResponse, patchData } = useHttp();

  const edit = useCallback(async (model: any) => {
    const associations = model;
    try {
      setIsSaving(true);
      const result = await patchData('EntityRelationship', associations);
      setIsSaving(false);
      if (result) {
        showSnackbar(['Association saved successfully!'], 'success');
        return true;
      }
    } catch (error) {
      console.log(`Exception while doing something: ${error}`);
      setIsSaving(false);
    }
  }, []);

  return { isSaving, data: patchDataResponse?.data ?? null, edit };
}
